const SOCKET_IO = process.env.REACT_APP_SOCKET_IO

export { SOCKET_IO }